import React from 'react'
import FadeInOut from "src/component/Global/FadeInOut"
import QuoteCartList from './QuoteCartList';
import QuoteCheckoutSummary from './QuoteCheckoutSummary';
import ShowAlert from 'src/component/Global/ShowAlert';

const QuoteCart = () => {
    return (
        <div className="logged-screen cart-container">
            <div className="container">
                <FadeInOut show={true} duration={100}>
                    <div className={"bs5 row"}>
                        <div className="col-xl-9">
                            <div className="col-12 m1-3">
                                <div className="cart-alert">
                                    <ShowAlert />
                                </div>
                            </div>
                            <QuoteCartList />
                        </div>
                        <div className="col-xl-3 mb-4 cart-right-wrapper">
                            <QuoteCheckoutSummary />
                        </div>
                    </div>
                </FadeInOut>
            </div>
        </div>
    )
}

export default QuoteCart